<template>
	<div class="bkf7 gameall_list" v-if="login && isAdmin">
		<el-container>
			<div class="inter2">
				<div class="filter-keywords-search" v-if="!isMobile">
					<div class="filter-search-label">关键词</div>
					<div class="filter-search-info">
						<div class="filter-search-input el-input el-input--suffix">
							<input type="text" autocomplete="off" v-model="keyword" placeholder="请输入关键字"
								class="el-input__inner"><span class="el-input__suffix">
								<span class="el-input__suffix-inner" @click="Search">
									<div class="search">搜索</div>
								</span></span>
						</div>
					</div>
				</div>
				<div class="mobile-filter-search" v-if="isMobile">
					<div class="mobile-search-box">
						<input type="text" v-model="keyword" placeholder="请输入关键字" class="mobile-search-input" />
						<button class="mobile-search-btn" @click="Search">搜索</button>
					</div>
				</div>
				<el-row>
					<div class="sortpaixu">
						<ul class="sortpaixu_ul">
							<li :class="{ 'active': sortactive == 1 }" @click="chose_sort(1)"><span>推荐排序</span></li>
							<li :class="{ 'active': sortactive == 2 }" @click="chose_sort(2, sort)">
								<span>结算比例</span><span v-if="sortactive == 2 && sort == 0">↑</span><span
									v-if="sortactive == 2 && sort == 1">↓</span>
							</li>
							<li :class="{ 'active': sortactive == 3 }" @click="chose_sort(3, sort)">
								<span>总资产</span><span v-if="sortactive == 3 && sort == 0">↑</span><span
									v-if="sortactive == 3 && sort == 1">↓</span>
							</li>
							<li :class="{ 'active': sortactive == 4 }" @click="chose_sort(4, sort)">
								<span>哈夫币</span><span v-if="sortactive == 4 && sort == 0">↑</span><span
									v-if="sortactive == 4 && sort == 1">↓</span>
							</li>
						</ul>
					</div>
				</el-row>
				<el-row v-if="isMobile">
					<div class="mobile_home_game" :key="mo_index">
						<div class="item" v-for="(item, index) in list">
							<div class="w_con1">
								<div class="wtext_1">
									<div class="image">
										<img src="@/assets/image/tu_biao.png" />
									</div>
									<div class="text">
										<p class="p1">{{ item.account_no || item.id }}</p>
										<p class="p2"> 编号：{{ item.account_no || item.id }} </p>
										<div class="p3">
											<div class="price1">
												<span class="sp1">￥</span>
												<span class="sp2">{{ item.price }}</span>
												<span class="sp3">租金</span>
											</div>
											<div class="price2">
												<span class="sp1">￥</span>
												<span class="sp2">{{ item.yajin }}</span>
												<span class="sp3">押金</span>
											</div>
										</div>
									</div>
								</div>
								<div class="wtext_2">
									<div class="text">
										<p class="p1">{{ item.daopi || '-' }}</p>
										<p class="p2">刀皮</p>
									</div>
									<div class="text">
										<p class="p1">{{ item.chunbi }}</p>
										<p class="p2">纯币资产(m)</p>
									</div>
									<div class="text">
										<p class="p1">{{ item.box }}</p>
										<p class="p2">安全箱</p>
									</div>
									<div class="text">
										<p class="p1">{{ item.awm }}</p>
										<p class="p2">AWM子弹</p>
									</div>
								</div>
								<div class="wtext_3">
									<div class="fr">
										<el-button size="mini" style="background: #1f9535; border-color: #1f9535; color: #fff; border-radius: 3px;" @click.stop="editAccount(item)">修改</el-button>
										<el-button size="mini" style="background: #52c41a; border-color: #52c41a; color: #fff; border-radius: 3px;" @click.stop="restoreAccount(item.id)">上架</el-button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</el-row>
				<el-row v-else>
					<el-col :span="24">
						<el-table :data="list" border style="width: 100%" @row-click="goToDetail" class="my-table">
							<el-table-column fixed="left" prop="account_no" label="编号" width="100">
							</el-table-column>
							<el-table-column prop="qufu" label="区服" width="80">
								<template slot-scope="scope">
									<span :class="scope.row.qufu === '2' ? 'color-wechat color-div' : 'color-qq color-div'">
										{{ scope.row.qufu == '2' ? '微信' : scope.row.qufu == '1' ? 'QQ' : '-' }}
									</span>
								</template>
							</el-table-column>
							<el-table-column align="center" width="100px" prop="login_type" label="登录方式">
								<template slot-scope="scope">
									<span :class="scope.row.login_type === '1' ? 'color-sm color-div' : 'color-qq color-div'">
										{{ scope.row.login_type == '1' ? '扫码登录' : scope.row.login_type == '2' ? '账号密码' : '-' }}
									</span>
								</template>
							</el-table-column>
							<el-table-column align="center" prop="is_ben" label="本人人脸" width="80">
								<template slot-scope="scope">
									<span>{{ scope.row.is_ben == '1' ? '是' : scope.row.is_ben == '0' ? '否' : '-' }}</span>
								</template>
							</el-table-column>
							<el-table-column align="center" prop="changzhu" label="常用登陆地" min-width="100">
								<template slot-scope="scope">
									<span>{{ getFilterName('changzhu', scope.row.changzhu) || scope.row.changzhu }}</span>
								</template>
							</el-table-column>
							<el-table-column align="center" prop="duanwei" label="段位" width="80">
								<template slot-scope="scope">
									<span v-if="scope.row.duanwei == 1">无段位</span>
									<span v-else-if="scope.row.duanwei == 2">青铜</span>
									<span v-else-if="scope.row.duanwei == 3">白银</span>
									<span v-else-if="scope.row.duanwei == 4">黄金</span>
									<span v-else-if="scope.row.duanwei == 5">铂金</span>
									<span v-else-if="scope.row.duanwei == 6">钻石</span>
									<span v-else-if="scope.row.duanwei == 7">黑鹰</span>
									<span v-else-if="scope.row.duanwei == 8">三角洲巅峰</span>
									<span v-else>{{ scope.row.duanwei }}</span>
								</template>
							</el-table-column>
							<el-table-column align="center" width="110px" prop="chunbi" label="纯币资产(m)">
								<template slot="header">
									<span>纯币资产(m)</span>
									<el-tooltip content="纯币资产单位 1M=100万" placement="top">
										<i class="el-icon-question" style="margin-left:5px;color:#45F4A9"></i>
									</el-tooltip>
								</template>
							</el-table-column>
							<el-table-column align="center" prop="bili" label="比例" width="70">
								<template slot="header">
									<span>比例</span>
									<el-tooltip content="以1：40为例，表示1元=40万哈夫币" placement="top">
										<i class="el-icon-question" style="margin-left:5px;color:#45F4A9"></i>
									</el-tooltip>
								</template>
							</el-table-column>
							<el-table-column align="center" prop="level" label="等级" width="70">
							</el-table-column>
							<el-table-column align="center" prop="xunlian" label="训练等级" min-width="90">
								<template slot-scope="scope">
									<span>{{ scope.row.xunlian }}级</span>
								</template>
							</el-table-column>
							<el-table-column align="center" prop="bachang" label="靶场等级" min-width="90">
								<template slot-scope="scope">
									<span>{{ scope.row.bachang }}级</span>
								</template>
							</el-table-column>
							<el-table-column align="center" min-width="120px" prop="box" label="安全箱">
								<template slot-scope="scope">
									<span class="color-sm color-div" :class="['color-div_box' + scope.row.box]">
										{{ getFilterName('box', scope.row.box) }}
									</span>
								</template>
							</el-table-column>
							<el-table-column align="center" min-width="90px" prop="awm" label="AWM子弹">
							</el-table-column>
							<el-table-column align="center" prop="daopi" label="刀皮" min-width="100">
								<template slot-scope="scope">
									<el-tooltip class="item" effect="dark" :content="getFilterNameList('daopi', scope.row.daopi)" placement="left">
										<span class="sp_text">{{ getFilterNameList('daopi', scope.row.daopi) }}</span>
									</el-tooltip>
								</template>
							</el-table-column>
							<el-table-column align="center" prop="ganyuan" label="干员皮" min-width="100">
								<template slot-scope="scope">
									<el-tooltip class="item" effect="dark" :content="getFilterNameList('ganyuan', scope.row.ganyuan)" placement="left">
										<span class="sp_text">{{ getFilterNameList('ganyuan', scope.row.ganyuan) }}</span>
									</el-tooltip>
								</template>
							</el-table-column>
							<el-table-column align="center" prop="wuqi" label="武器皮" min-width="100">
								<template slot-scope="scope">
									<el-tooltip class="item" effect="dark" :content="getFilterNameList('wuqi', scope.row.wuqi)" placement="left">
										<span class="sp_text">{{ getFilterNameList('wuqi', scope.row.wuqi) }}</span>
									</el-tooltip>
								</template>
							</el-table-column>
							<el-table-column align="center" prop="price" label="价格(元)" min-width="80">
							</el-table-column>
							<el-table-column align="center" prop="yajin" label="押金(元)" min-width="80">
							</el-table-column>
							<el-table-column align="center" prop="kd" label="KD" min-width="60">
								<template slot-scope="scope">
									<span>{{ scope.row.kd || '-' }}</span>
								</template>
							</el-table-column>
							<el-table-column align="center" prop="beizhu" label="备注" min-width="120">
								<template slot-scope="scope">
									<el-tooltip class="item" effect="dark" :content="scope.row.beizhu" placement="left">
										<span class="sp_text">{{ scope.row.beizhu }}</span>
									</el-tooltip>
								</template>
							</el-table-column>
							<el-table-column align="center" fixed="right" label="操作" width="200">
								<template slot-scope="scope">
									<el-button size="mini" style="background: #1f9535; border-color: #1f9535; color: #fff; border-radius: 3px;" @click.stop="editAccount(scope.row)">修改</el-button>
									<el-button size="mini" style="background: #52c41a; border-color: #52c41a; color: #fff; border-radius: 3px;" @click.stop="restoreAccount(scope.row.id)">上架</el-button>
								</template>
							</el-table-column>
						</el-table>
					</el-col>
				</el-row>
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="page"
					:page-sizes="[10, 20, 30, 40]"
					:page-size="limit"
					layout="total, sizes, prev, pager, next, jumper"
					:total="total">
				</el-pagination>
				<el-dialog title="编辑账号" :visible.sync="dialogVisible" width="900px" top="5vh">
					<el-form :model="form" label-width="100px">
						<el-row :gutter="20">
							<el-col :span="8">
								<el-form-item label="选择客服">
									<el-select v-model="form.kefu_id" placeholder="请选择客服" style="width: 100%;">
										<el-option v-for="item in kefuList" :key="item.id"
											:label="item.kefu_code + ' - ' + item.name" :value="item.id"></el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="8">
								<el-form-item label="游戏区服">
									<el-select v-model="form.qufu" placeholder="游戏区服" style="width: 100%;">
										<el-option label="QQ" value="1"></el-option>
										<el-option label="微信" value="2"></el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="8">
								<el-form-item label="仓库总资产">
									<el-input v-model="form.zichan" placeholder="仓库总资产" style="width: 100%;"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row :gutter="20">
							<el-col :span="8">
								<el-form-item label="纯币数量(M)">
									<el-input v-model="form.chunbi" placeholder="纯币数量" style="width: 100%;" @input="calculateRent('chunbi')"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="8">
								<el-form-item label="段位">
									<el-select v-model="form.duanwei" placeholder="段位" style="width: 100%;">
										<el-option label="无段位" value="1"></el-option>
										<el-option label="青铜" value="2"></el-option>
										<el-option label="白银" value="3"></el-option>
										<el-option label="黄金" value="4"></el-option>
										<el-option label="铂金" value="5"></el-option>
										<el-option label="钻石" value="6"></el-option>
										<el-option label="黑鹰" value="7"></el-option>
										<el-option label="三角洲巅峰" value="8"></el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="8">
								<el-form-item label="保险">
									<el-select v-model="form.box" placeholder="保险" style="width: 100%;">
										<el-option label="2格" value="1"></el-option>
										<el-option label="4格" value="2"></el-option>
										<el-option label="6格" value="3"></el-option>
										<el-option label="9格" value="4"></el-option>
									</el-select>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row :gutter="20">
							<el-col :span="8">
								<el-form-item label="训练">
									<el-input type="number" v-model="form.xunlian" placeholder="1-7" style="width: 100%;"
										min="1" max="7"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="8">
								<el-form-item label="靶场">
									<el-input type="number" v-model="form.bachang" placeholder="1-7" style="width: 100%;"
										min="1" max="7"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="8">
								<el-form-item label="登录方式">
									<el-select v-model="form.login_type" placeholder="登录方式" style="width: 100%;">
										<el-option label="扫码登录" value="1"></el-option>
										<el-option label="账密登录" value="2"></el-option>
									</el-select>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row :gutter="20">
							<el-col :span="8">
								<el-form-item label="封禁记录">
									<el-select v-model="form.is_feng" placeholder="封禁记录" style="width: 100%;">
										<el-option label="无" value="1"></el-option>
										<el-option label="有记录" value="2"></el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="8">
								<el-form-item label="本人人脸">
									<el-select v-model="form.is_ben" placeholder="是否本人人脸" style="width: 100%;">
										<el-option label="是" value="1"></el-option>
										<el-option label="否" value="0"></el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="8">
								<el-form-item label="游戏等级">
									<el-input v-model="form.level" placeholder="等级" style="width: 100%;"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row :gutter="20">
							<el-col :span="24">
								<el-form-item label="干员皮">
									<el-select multiple v-model="form.ganyuan" placeholder="干员皮" style="width: 100%;">
										<el-option label="红狼 - 蚀金玫瑰" value="1"></el-option>
										<el-option label="红狼 - 黑鹰坠落" value="2"></el-option>
										<el-option label="威龙 - 蛟龙行动" value="3"></el-option>
										<el-option label="威龙 - 铁面判官" value="4"></el-option>
										<el-option label="威龙 - 吴彦祖" value="5"></el-option>
										<el-option label="蜂医 - 送葬人" value="6"></el-option>
										<el-option label="蜂医 - 黑鹰坠落" value="7"></el-option>
										<el-option label="蜂医 - 危险物质" value="8"></el-option>
										<el-option label="无名 - 夜鹰" value="9"></el-option>
										<el-option label="乌鲁售・黑鹰坠落" value="10"></el-option>
										<el-option label="牧羊人 - 黑鹰坠落" value="11"></el-option>
										<el-option label="牧羊人 - 街头之王" value="12"></el-option>
										<el-option label="露娜 - 黑 - 天际线" value="13"></el-option>
										<el-option label="蛊 - 能天使 - 午夜邮差" value="14"></el-option>
										<el-option label="骇爪 - 维什戴尔" value="15"></el-option>
										<el-option label="骇爪 - 水墨云图" value="16"></el-option>
										<el-option label="露娜 - 金牌射手" value="17"></el-option>
										<el-option label="深蓝 - 不破之誓" value="18"></el-option>
										<el-option label="红狼 - 电锯惊魂" value="19"></el-option>
										<el-option label="威龙 - 凌霄戍卫" value="20"></el-option>
									</el-select>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row :gutter="20">
							<el-col :span="12">
								<el-form-item label="刀皮">
									<el-select multiple v-model="form.daopi" placeholder="刀皮" style="width: 100%;">
										<el-option label="信条" value="1"></el-option>
										<el-option label="赤霄" value="2"></el-option>
										<el-option label="怜悯" value="3"></el-option>
										<el-option label="影锋" value="4"></el-option>
										<el-option label="黑海" value="5"></el-option>
										<el-option label="北极星" value="6"></el-option>
										<el-option label="电锯惊魂" value="7"></el-option>
										<el-option label="龙牙" value="8"></el-option>
										<el-option label="暗星" value="9"></el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="武器皮">
									<el-select multiple v-model="form.wuqi" placeholder="武器皮" style="width: 100%;">
										<el-option label="M7 棱镜攻势" value="1"></el-option>
										<el-option label="M4 棱镜攻势" value="2"></el-option>
										<el-option label="K416 - 命运" value="3"></el-option>
										<el-option label="SCAR - 电玩" value="4"></el-option>
										<el-option label="腾龙 - 气象感应" value="5"></el-option>
										<el-option label="QBZ95 - 王牌之剑" value="6"></el-option>
										<el-option label="Vctor - 中锋枪 - 美杜莎" value="7"></el-option>
										<el-option label="AS Val 突击步枪 - 悬赏令" value="8"></el-option>
										<el-option label="AUG - 气象感应" value="9"></el-option>
									</el-select>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row :gutter="20">
							<el-col :span="6">
								<el-form-item label="AWM子弹">
									<el-input v-model="form.awm" placeholder="AWM子弹" style="width: 100%;"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="六套数量">
									<el-input v-model="form.liutao" placeholder="0-60" style="width: 100%;"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="比例">
									<el-input v-model="form.bili" placeholder="比例" style="width: 100%;" @input="calculateRent('bili')"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="价格(元)">
									<el-input v-model="form.price" placeholder="租金" style="width: 100%;" @input="calculateRent('price')"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row :gutter="20">
							<el-col :span="6">
								<el-form-item label="押金(元)">
									<el-input v-model="form.yajin" placeholder="押金" style="width: 100%;"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="IP地址">
									<el-input v-model="form.changzhu" placeholder="IP地址" style="width: 100%;"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="KD">
									<el-input v-model="form.kd" placeholder="KD" style="width: 100%;"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="租期(天)">
									<el-input v-model="form.zuqi" placeholder="租期" style="width: 100%;"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row :gutter="20">
							<el-col :span="24">
								<el-form-item label="备注">
									<el-input type="textarea" v-model="form.beizhu" placeholder="备注"
										style="width: 100%;"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
					</el-form>
					<div slot="footer" class="dialog-footer">
						<el-button style="background: #f5f5f5; border-color: #d9d9d9; color: #333; border-radius: 3px;" @click="dialogVisible = false">取消</el-button>
						<el-button style="background: #1f9535; border-color: #1f9535; color: #fff; border-radius: 3px;" @click="saveEdit">保存</el-button>
					</div>
				</el-dialog>
			</div>
		</el-container>
	</div>
	<div v-else>
		<el-alert title="请登录管理员账号访问" type="warning" show-icon />
	</div>
</template>
<script>
export default {
	data() {
			return {
				keyword: '',
				page: 1,
				limit: 20,
				total: 0,
				list: [],
				loading: false,
				sortactive: 1,
				sort: 0,
				dialogVisible: false,
				mo_index: 0,
				form: {
					id: '',
					kefu_id: '',
					login_type: '',
					is_feng: '',
					is_ben: '',
					level: '',
					zichan: '',
					chunbi: '',
					box: '',
					xunlian: '',
					bachang: '',
					kd: '',
					duanwei: '',
					ganyuan: [],
					daopi: [],
					wuqi: [],
					awm: '',
					liutao: '',
					bili: '',
					price: '',
					yajin: '',
					changzhu: '',
					changzhu_text: '',
					qufu: '',
					zuqi: '',
					beizhu: ''
				}
			}
		},
	computed: {
		login() {
			return this.$store.getters.login
		},
		userinfo() {
			return this.$store.getters.userinfo
		},
		isMobile() {
			return this.$store.getters.isMobile
		},
		gamelist() {
			return this.$store.getters.gamelist
		},
		config() {
			return this.$store.getters.config
		},
		allGameList() {
			return this.$store.getters.allGameList
		},
		isAdmin() {
			return this.$store.getters.isAdmin
		}
	},
	mounted() {
		this.getList()
	},
	methods: {
		getFilterName(type, value) {
			if (!value && value !== 0) return '-'
			const map = {
				box: { '1': '2格', '2': '4格', '3': '6格', '4': '9格' },
				duanwei: { '1': '无段位', '2': '青铜', '3': '白银', '4': '黄金', '5': '铂金', '6': '钻石', '7': '黑鹰', '8': '三角洲巅峰' }
			}
			return map[type] && map[type][value] ? map[type][value] : value
		},
		getFilterNameList(type, value) {
			if (!value) return '-'
			const map = {
				daopi: { '1': '信条', '2': '赤霄', '3': '怜悯', '4': '影锋', '5': '黑海', '6': '北极星', '7': '电锯惊魂', '8': '龙牙', '9': '暗星' },
				ganyuan: { '1': '红狼 - 蚀金玫瑰', '2': '红狼 - 黑鹰坠落', '3': '威龙 - 蛟龙行动', '4': '威龙 - 铁面判官', '5': '威龙 - 吴彦祖', '6': '蜂医 - 送葬人', '7': '蜂医 - 黑鹰坠落', '8': '蜂医 - 危险物质', '9': '无名 - 夜鹰', '10': '乌鲁售・黑鹰坠落', '11': '牧羊人 - 黑鹰坠落', '12': '牧羊人 - 街头之王', '13': '露娜 - 黑 - 天际线', '14': '蛊 - 能天使 - 午夜邮差', '15': '骇爪 - 维什戴尔', '16': '骇爪 - 水墨云图', '17': '露娜 - 金牌射手', '18': '深蓝 - 不破之誓', '19': '红狼 - 电锯惊魂', '20': '威龙 - 凌霄戍卫' },
				wuqi: { '1': 'M7 棱镜攻势', '2': 'M4 棱镜攻势', '3': 'K416 - 命运', '4': 'SCAR - 电玩', '5': '腾龙 - 气象感应', '6': 'QBZ95 - 王牌之剑', '7': 'Vctor - 中锋枪 - 美杜莎', '8': 'AS Val 突击步枪 - 悬赏令', '9': 'AUG - 气象感应' }
			}
			if (!map[type]) return value
			const list = value.split(',').map(v => map[type][v] || v)
			return list.join(', ')
		},
		goToDetail(row) {
			window.location.href = '/goodsdetail?id=' + row.id
		},

		calculateRent(source) {
			const chunbi = parseFloat(this.form.chunbi) || 0;
			const bili = parseFloat(this.form.bili) || 0;
			const price = parseFloat(this.form.price) || 0;
			if (chunbi > 0) {
				this.form.zuqi = (chunbi / 10).toFixed(1);
			}
			if (source === 'chunbi' || source === 'bili') {
				if (chunbi > 0 && bili > 0) {
					this.form.price = ((chunbi / bili) * 100).toFixed(2);
				}
			} else if (source === 'price') {
				if (chunbi > 0 && price > 0) {
					this.form.bili = Math.round((chunbi / price) * 100 * 10) / 10;
				}
			}
		},
		getList() {
			this.loading = true
			this.rq.requests.post('api/game/hall/getSuspendedAccounts', {
				page: this.page,
				limit: this.limit,
				keyword: this.keyword,
				sortactive: this.sortactive,
				sort: this.sort
			}).then(res => {
				this.list = res.data.data
				this.total = res.data.total
				this.loading = false
			})
		},
		Search() {
			this.page = 1
			this.getList()
		},
		chose_sort(sortactive, sort) {
			this.sortactive = sortactive
			this.sort = sort === 0 ? 1 : 0
			this.page = 1
			this.getList()
		},
		handleSizeChange(val) {
			this.limit = val
			this.page = 1
			this.getList()
		},
		handleCurrentChange(val) {
			this.page = val
			this.getList()
		},
		editAccount(row) {
			this.form = Object.assign({}, row)
			if (this.form.daopi && typeof this.form.daopi === 'string') {
				this.form.daopi = this.form.daopi ? this.form.daopi.split(',') : []
			}
			if (this.form.wuqi && typeof this.form.wuqi === 'string') {
				this.form.wuqi = this.form.wuqi ? this.form.wuqi.split(',') : []
			}
			if (this.form.ganyuan && typeof this.form.ganyuan === 'string') {
				this.form.ganyuan = this.form.ganyuan ? this.form.ganyuan.split(',') : []
			}
			const changzhuMap = {
				1: '北京', 2: '天津', 3: '河北', 4: '山西', 5: '内蒙古', 6: '辽宁', 7: '吉林', 8: '黑龙江',
				9: '上海', 10: '江苏', 11: '浙江', 12: '安徽', 13: '福建', 14: '江西', 15: '山东', 16: '河南',
				17: '湖北', 18: '湖南', 19: '广东', 20: '广西', 21: '海南', 22: '重庆', 23: '四川', 24: '贵州',
				25: '云南', 26: '西藏', 27: '陕西', 28: '甘肃', 29: '青海', 30: '宁夏', 31: '新疆', 32: '台湾',
				33: '香港', 34: '澳门'
			}
			this.form.changzhu_text = changzhuMap[this.form.changzhu] || ''
			this.dialogVisible = true
		},
		saveEdit() {
			const formData = Object.assign({}, this.form)
			if (Array.isArray(formData.daopi)) {
				formData.daopi = formData.daopi.join(',')
			}
			if (Array.isArray(formData.wuqi)) {
				formData.wuqi = formData.wuqi.join(',')
			}
			if (Array.isArray(formData.ganyuan)) {
				formData.ganyuan = formData.ganyuan.join(',')
			}
			this.rq.requests.post('api/game/hall/updateAccount', formData).then(res => {
				this.$message.success('修改成功')
				this.dialogVisible = false
				this.getList()
			}).catch(err => {
				this.$message.error('修改失败：' + (err.data && err.data.msg ? err.data.msg : '未知错误'))
			})
		},
		restoreAccount(id) {
			this.rq.requests.post('api/game/hall/restoreAccount', { id: id }).then(res => {
				this.$message.success('上架成功')
				this.getList()
			})
		}
	}
}
</script>
<style scoped>
.filter-keywords-search {
	display: flex;
	align-items: center;
	padding: 15px 20px;
	background: #fff;
	border-radius: 8px;
	margin-bottom: 15px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}
.filter-search-label {
	width: 70px;
	font-size: 14px;
	font-weight: 500;
	color: #acb6c2;
}
.filter-search-info {
	flex: 1;
	display: flex;
	align-items: center;
}
.filter-search-input {
	flex: 1;
	max-width: 400px;
}
.filter-search-input input {
	height: 36px;
	line-height: 36px;
	border: 1px solid #dcdfe6;
	border-radius: 4px;
	padding: 0 50px 0 15px;
	font-size: 14px;
	transition: border-color 0.3s;
}
.filter-search-input input:focus {
	border-color: #1f9535;
	outline: none;
}
.search {
	width: 50px;
	height: 100%;
	line-height: 36px;
	text-align: center;
	color: #1f9535;
	border-radius: 0 4px 4px 0;
	cursor: pointer;
	font-size: 14px;
	transition: background 0.3s;
}
.search:hover {
	background: #17822b;
}
.mobile-filter-search {
	padding: 10px;
	background: #fff;
	margin-bottom: 10px;
}
.mobile-search-box {
	display: flex;
	gap: 10px;
}
.mobile-search-input {
	flex: 1;
	height: 36px;
	padding: 0 12px;
	border: 1px solid #ddd;
	border-radius: 4px;
	font-size: 14px;
}
.mobile-search-btn {
	padding: 0 20px;
	height: 36px;
	background: #1f9535;
	color: #fff;
	border: none;
	border-radius: 4px;
	cursor: pointer;
	font-size: 14px;
}
</style>